export function normalizePaymentVendorType (value) {
  return String(value || '').toUpperCase().replace(/[-_\s]/g, '')
}

export function isDokuPaymentVendor (value) {
  return ['DOKU', 'DOKUSNAP'].includes(normalizePaymentVendorType(value))
}

export function isBcaPaymentVendor (value) {
  return ['BCA', 'BCASNAP'].includes(normalizePaymentVendorType(value))
}

export function isBniPaymentVendor (value) {
  return ['BNI', 'BNISNAP'].includes(normalizePaymentVendorType(value))
}

export function isSnapPaymentVendor (value) {
  return isDokuPaymentVendor(value) || isBcaPaymentVendor(value) || isBniPaymentVendor(value)
}

export function isMidtransPaymentVendor (value) {
  return normalizePaymentVendorType(value) === 'MIDTRANS'
}
